import "../../styles/listPayment.scss";
import { changeCurrancyFormat, decode_utf8, getCurrentTime, getSignedIdStatus } from "../../../../common/utils/utilsFunc";
import { LiferayService } from "../../../../common/services/liferay/index";
import Loading from "../../../../common/components/Loading";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import PaymentList from "../PaymentList"
import React, { useState, useEffect, useContext } from "react";
import DeudaActualYVencidaContextProvider, {
    DeudaActualYVencidaContext,
    ACTIONS
} from "../../context/DeudaActualYVencidaContextProvider";
import { CGE } from "../../../../common/components/CGE";
import { ClayRadio, ClayRadioGroup } from "@clayui/form";
import { getLiferayAuthenticationToken } from "../../../../common/services/liferay/api";

const DebtCurrentOverdue = ({props}) => {
    const [state, dispatch] = useContext(DeudaActualYVencidaContext);
    const data = state.idList ? state.idList : [];
    const [valueRadio, setValueRadio] = React.useState("");
    const [valueRadioDebt, setValueRadioDebt] = React.useState("");

    const [inputSearch, setInputSearch] = useState("");
    const [inputSelected, setInputSelected] = useState("");

    const [loading, setLoading] = useState(false);

    const [showWebContent, setShowWebContent] = useState(false);
    const [webContentHtml, setWebContentHtml] = useState("");


    const [debtCurrent, setDebtCurrent] = useState(0);
    const [debtInvoiced, setDebtInvoiced] = useState(0);
    const [debtInvoicedOverdue, setDebtInvoicedOverdue] = useState(0);
    const [debtInvoicedOverdueTercera, setDebtInvoicedOverdueTercera] = useState(0);
    const [debtOverdue, setDebtOverdue] = useState(0);

    const [msgErrorCli, setMsgErrorCli] = useState("");
    const [showErrorCli, setShowErrorCli] = useState(false);

    const [msgErrorDoc, setMsgErrorDoc] = useState("");
    const [showErrorDoc, setShowErrorDoc] = useState(false);

    const [msgErrorCupon, setMsgErrorCupon] = useState("");
    const [showErrorCupon, setShowErrorCupon] = useState(false);


    function handleButtonDebt() {
        setShowErrorDoc(false);
        const auxValueRadio = valueRadioDebt?Number(valueRadioDebt):0;

        if(auxValueRadio && inputSelected && !showErrorDoc && !showErrorCli) {
            window.location.href = `detalle-de-cuenta-priv?ctacto=${inputSelected}&typeDebt=${auxValueRadio}`;
        } else if (auxValueRadio === 0) {
            setShowErrorDoc(true);
            setMsgErrorDoc("Elija el documento que necesita cancelar");
        } else {
            setShowErrorDoc(true);
            setMsgErrorDoc("Seleccionar cliente");
        }
        
    }

    function handleButtonTicket() {
        let valueTicket = null;
        switch (valueRadio) {
            case "L" : 
                valueTicket = debtInvoiced
            break;
            case "T" : 
                valueTicket = debtInvoicedOverdue
            break;
            case "A" : 
                valueTicket = debtInvoicedOverdueTercera
            break;
            default:
                valueTicket = valueTicket;
            break;
        }
        if(!valueTicket){
          props.setGlobalAlert("Seleccione la boleta para emitir el cupón de pago.", "warning")

        } else {
         setLoading(true)
  
          LiferayService.getCouponCc(props.base_url_api, [inputSelected, valueRadio], props.codigo_empresa, props.url_ws_empresa).then((response) => {
            if (response?.code === 0) {
                let base64String = Buffer.from(response?.codCupon, "hex").toString("base64");
                let link = document.createElement('a');
                link.download = `CuponDePagos_${getCurrentTime()}.pdf`;
                link.href = 'data:application/octet-stream;base64,'+base64String;
                link.click();
            } else {
                props.setGlobalAlert(response.mensaje ? response.mensaje : decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
            }
            setLoading(false);
        })
        }
    }

    useEffect(() => {
        if (state.saldoCross.length !== 0) {
            setShowErrorDoc(false);
        }

        const dataJson = state.saldoCross;

        if (dataJson?.code >= 0) {
            switch (Number(dataJson.code)) {
                case 0:
                    setDebtCurrent(Number(dataJson.deudaActual));
                    setDebtOverdue(Number(dataJson.deudaVencida));
                    setShowErrorCli(false);
                    dispatch({
                        payload: [ getSignedIdStatus() ? "OV" : "URL", inputSelected],
                        type: ACTIONS.SET_BODY_DCC,
                    })
                    break;
                case 1:
                    setShowErrorCli(true);
                    setMsgErrorCli(dataJson.mensaje);
                    setLoading(false);

                    break;
                default:
                    setShowErrorDoc(true);
                    setMsgErrorDoc("El servicio no está disponible actualmente, intente más tarde.");
                    setLoading(false);

                    break;
            }
        } else {
            setMsgErrorDoc("El servicio no está disponible actualmente, intente más tarde.");
            setShowErrorDoc(true);
            setLoading(false);
        }

    }, [state.saldoCross]);

    useEffect(() => {
        if (state.debtCc.length !== 0) {
            setLoading(false);
            setShowErrorCupon(false);
        }

        const dataJson = state.debtCc;

        if (dataJson?.code >= 0) {
            switch (Number(dataJson.code)) {
                case 0:
                    setDebtInvoiced(Number(dataJson.edatosCupon.ultBoleta));
                    setDebtInvoicedOverdue(Number(dataJson.edatosCupon.antBoleta));
                    setDebtInvoicedOverdueTercera(Number(dataJson.edatosCupon.terBoleta));
                    break;
                case 1:
                    setShowErrorCupon(true);
                    setMsgErrorCupon(dataJson.mensaje);

                    break;
                default:
                    setShowErrorCupon(true);
                    setMsgErrorCupon("El servicio no está disponible actualmente, intente más tarde.");
                    break;
            }
        } else {
            setShowErrorCupon(true);
            setMsgErrorCupon("El servicio no está disponible actualmente, intente más tarde.");
        }

    }, [state.debtCc]);

    useEffect(() => {
        setShowErrorCli(false);
        setShowErrorCupon(false);
        setShowErrorDoc(false);

        setDebtCurrent(0);
        setDebtInvoiced(0);
        setDebtInvoicedOverdue(0);
        setDebtInvoicedOverdueTercera(0);
        setDebtOverdue(0);

        if (inputSelected !== "") {
            setInputSearch("");

            setLoading(true);
            dispatch({
                payload: ["OVIRTUAL", inputSelected],
                type: ACTIONS.SET_BODY_SC,
            }
            )

        } else {
            setDebtCurrent(0);
            setDebtOverdue(0);
            setShowErrorDoc(false);
        }

    }, [inputSelected]);

    useEffect(() => {

        if (state.webContentText !== "ERROR") {
            setShowWebContent(true);
            setWebContentHtml(state.webContentText);
        } else {
            setShowErrorCupon(true);
            setMsgErrorCupon("La lista de pagos no está disponible, intente más tarde.");
            setShowWebContent(false);
            setWebContentHtml("");
        }

    }, [state.webContentText]);

    useEffect(() => {

        if (inputSearch !== "") {
            if (data.find((obj) => obj.toString() === inputSearch)) {
                setInputSelected(inputSearch);
                document.getElementById("mySelectId").value = inputSearch;
            }
        }

    }, [inputSearch]);

    useEffect(() => {
        setLoading(false);
    }, [state.idList]);

    useEffect(() => {
        setLoading(true);
        dispatch({
            payload: true,
            type: ACTIONS.SET_LOAD_PAGE,
        });
    }, []);

    React.useEffect(() => {
        if(showErrorCli){
            props.setGlobalAlert(msgErrorCli,"warning", true, "Advertencia"); 
        }
    }, [showErrorCli])

    React.useEffect(() => {
        if(showErrorDoc && !showErrorCli){
            props.setGlobalAlert(msgErrorDoc,"warning", true, "Advertencia"); 

        }
    }, [showErrorDoc])

    React.useEffect(() => {

        if(showErrorCupon && !showErrorCli){
            props.setGlobalAlert(msgErrorCupon,"warning", true, "Advertencia"); 
        }
    }, [showErrorCupon])
    
    return (
        <>
            <div class="rounded bg-white" >
                <HeaderSearch
                    data={data}
                    setSearch={setInputSearch}
                    setSelected={setInputSelected}
                    idClient={inputSelected}
                    inputSearch={inputSearch}
                />
            </div>
            <div id="debtCurrentOverdue" className="container-table cge-payment-detail">
                <CGE.Panel title="Deuda Actual y Vencida">
                    <CGE.PanelSectionTicket title="Elija el documento que necesita cancelar">
                        <CGE.Text size="7" text="Seleccione el documento que necesita cancelar:" style={{ color: 'black' }} />
                        <CGE.Spacing type="sm" />
                        <ClayRadioGroup
                            className="ClayRadioGrup cge-checkBox-ticket"
                            inline
                            onSelectedValueChange={(value) => {
                                setValueRadioDebt(value);
                            }}
                            selectedValue={valueRadioDebt}
                        >
                            <ClayRadio className="color-black" label={`Deuda Actual ${changeCurrancyFormat(debtCurrent)}`}  disabled={debtCurrent === 0 }   value="1" />
                            <ClayRadio label={`Deuda Vencida ${changeCurrancyFormat(debtOverdue)}`} disabled={debtOverdue === 0} value="2" />
                        </ClayRadioGroup>
                        <div className="col-md-12 d-flex align-items-center flex-column">
                            <CGE.Button
                                size="sm"
                                label="¡Pagar Aquí!"
                                onClick={() => handleButtonDebt()}
                                type="primary"
                            />
                            <CGE.Spacing type="ct" />
                        </div>
                    </CGE.PanelSectionTicket>
                    <CGE.PanelSectionTicket title="Emision de Cupón de Pago">
                        <CGE.Text size="7" text="Seleccione la boleta para emitir el cupón de pago:" style={{ color: 'black' }} />
                        <CGE.Spacing type="sm" />
                        <ClayRadioGroup
                            className="ClayRadioGrup cge-checkBox-ticket"
                            inline
                            onSelectedValueChange={(value) => {
                                setValueRadio(value);
                            }}
                            selectedValue={valueRadio}
                        >
                            <ClayRadio className="color-black" label={`Ultima Boleta ${changeCurrancyFormat(debtInvoiced)}`}  disabled={debtInvoiced === 0 }   value="L" />
                            <ClayRadio label={`Boleta Anterior ${changeCurrancyFormat(debtInvoicedOverdue)}`} disabled={debtInvoicedOverdue === 0} value="A" />
                            <ClayRadio label={`Tercera Boleta ${changeCurrancyFormat(debtInvoicedOverdueTercera)}`} disabled={debtInvoicedOverdueTercera === 0} value="T"/>
                        </ClayRadioGroup>
                        <CGE.Spacing type="md"/>
                        <div className="col-md-12">
                            {showWebContent && <PaymentList htmlValue={webContentHtml} />}
                        </div>
                        <div className="col-md-12 d-flex align-items-center flex-column">
                            <CGE.Button
                                size="sm"
                                label="Emitir Cupón de Pago"
                                onClick={() => handleButtonTicket()}
                                type="primary"
                            />
                            <CGE.Spacing type="ct" />
                        </div>
                    </CGE.PanelSectionTicket>
                    {loading && <Loading />}
                </CGE.Panel>
            </div>
        </>
    );
};

const DebtCurrentOverdueWithProvider = ({props}) => (
    <DeudaActualYVencidaContextProvider>
        <DebtCurrentOverdue props={props} />
    </DeudaActualYVencidaContextProvider>
);
export default DebtCurrentOverdueWithProvider;
